import { pathToRegexp, match } from 'path-to-regexp';

export default class CustomRouter {
    constructor({ routes }) {
        this.route = routes.find((route) => {

            const r =  pathToRegexp(route.path);
            /**
             * Если путь `URL` совпадает с шаблоном пути списка роутов, то `true`
             */
            const isRoute = r.test(window.location.pathname);

            return isRoute;
        });
    }

    async init() {
        if (!this.route) return {};

        const page = await this.route.component();

        /**
         * Объект, совместимый с объектом Vue Router
         */
        const route = match(this.route.path)(window.location.pathname);
        route.query = Object.fromEntries(new URLSearchParams(window.location.search));
        route.name = this.route.name;

        const router = {
            push: (url) => location.href = url,
        };

        return {
            data() {
                return {
                    ...(typeof page.default.data === 'function' ? page.default.data() : {}),
                    route,
                    router,
                };
            },
            components: page.default.components,
            mixins: page.default.mixins,
            directives: page.default.directives,
            methods: page.default.methods,
            computed: page.default.computed,
            watch: page.default.watch,
            provide: {
                ...(page.default.provide ?? {}),
                route,
                router,
            },
            inject: page.default.inject,
            mounted() {
                if (typeof page.default.mounted === 'function') page.default.mounted();
            },
        };
    }
}

